const blog = {
    UPDATE_ENVS: 'blog.update_envs',
};

const environment = {
    UPDATE_ENVS: 'environment.update_envs',
};

// const page = {
//     UPDATE_SECTION: 'page.update_section',
// };

// const user = {
//     SET_USER_DATA:    'user.set_user_data',
//     UPDATE_USER_DATA: 'user.update_user_data',
//     CLEAR_USER_DATA:  'user.clear_user_data',
// };

const storeTypes = {
    BLOG:        blog,
    ENVIRONMENT: environment,
    // PAGE:    page,
    // USER:    user,
};
export default storeTypes;

export { blog, environment };
